import React from 'react';

export default function GeneralSalesReturn() {
	return <div></div>;
}
